import { restClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

const q = (p: Record<string, unknown>) => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== undefined && v !== null && v !== '').reduce((a, [k, v]) => ({ ...a, [k]: String(v) }), {})
).toString()

export const trackingService = {
  // Active users (re-uses the standard user list endpoint)
  activeUsers: (p: { page?: number; limit?: number; search?: string } = {}) => {
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15 }
    if (p.search) params.search = p.search
    return restClient.get(`${endpoints.users.list}?${q(params)}`).then(r => r.data)
  },
  deletedUsers: (p: { page?: number; limit?: number; search?: string } = {}) => {
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15 }
    if (p.search) params.search = p.search
    return restClient.get(`${endpoints.users.tracking}/deleted/all?${q(params)}`).then(r => r.data)
  },
  deleteUser: (userId: number) => restClient.post(`${endpoints.users.tracking}/${userId}/delete`, {}).then(r => r.data),
  restoreUser: (userId: number) => restClient.post(`${endpoints.users.tracking}/${userId}/restore`, {}).then(r => r.data),
}
